





























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import {
  getDiagramApi,
  postDiagramApi
} from "@/typescript/api_client/emesh_api/stores/diagram_api";
import { postStoresDiagramApi } from "@/typescript/api_client/emesh_api/stores/stores_diagram_api";
import { getRoutePath } from "../../../router/routes";
//import { getImage } from "@/typescript/lib/common/get_image";
import { getDiagramImageApi } from "@/typescript/api_client/emesh_api/stores/diagram_image_api";
import { download } from "@/typescript/lib/common/download";
import { GetDiagramResponse } from "../../../typescript/api_client/emesh_api/stores/types";
import { convertPdf } from "@/typescript/lib/common/convert_pdf";
export { GetDiagramResponse };

@Component({
  components: {
    SelectComponent,
    ButtonComponent
  }
})
export default class SensorMenuModalComponent extends Vue {
  $refs!: {
    diagram_file: any;
    canvas: any;
  };

  fileName: string = "";

  activeTab: string = "template";
  isOpen: boolean = false;
  options: GetDiagramResponse[] = [];
  selectedImage: any = {};

  // ドラッグ＆ドロップのドラッグ中の見た目変更用
  isDrag: boolean = false;

  created() {
    this.setApiData();
  }

  @Watch("isOpen")
  reset() {
    this.setApiData();
    this.activeTab = "template";
    this.fileName = "";
  }

  async setApiData() {
    const diagrams = await getDiagramApi(this.$route.params.store_id);
    this.options = diagrams;
    const storeDiagram = diagrams.find(
      d => d.diagram_id === Number(this.$route.query.diagram_id)
    );
    if (!storeDiagram) return "";
    storeDiagram.url = "";
    this.selectedImage = storeDiagram;
  }

  switchMenu(tab: string) {
    this.activeTab = tab;
  }
  isActiveTab(tab: string) {
    return this.activeTab === tab;
  }
  openModal() {
    this.isOpen = true;
  }
  closeModal() {
    this.isOpen = false;
  }

  async onChange(selected) {
    selected.url = "";
    this.selectedImage = selected;
    //const resp = await getImage(this.selectedImage.url);
    const resp = await getDiagramImageApi(this.selectedImage.diagram_id);
    if (resp.headers["content-type"] === "application/pdf") {
      const png = await convertPdf(resp.data, this.$refs.canvas);
      this.$set(this.selectedImage, "pdf", png);
    } else {
      const file = new File([resp.data], "image", {
        type: resp.headers["content-type"]
      });
      //const file = resp.data;
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          // 画像ファイルを base64 文字列に変換
          if (typeof reader.result === "string")
            this.selectedImage.url = reader.result;
        },
        false
      );
      reader.readAsDataURL(file);
    }
  }

  async downloadImage() {
    //const resp = await getImage(this.selectedImage.url);
    const resp = await getDiagramImageApi(this.selectedImage.diagram_id);
    download(resp.data, this.selectedImage.diagram_name);
  }

  selectReflect() {
    const storeId = this.$route.params.store_id;
    const diagramId = this.selectedImage.diagram_id;
    postStoresDiagramApi(storeId, diagramId).then(() => {
      this.$router.push({
        path: getRoutePath("SensorDiagramsEditPage", {
          store_id: storeId
        }),
        query: { diagram_id: String(diagramId) }
      });
      this.$router.go({ path: this.$router.currentRoute.path } as any);
      this.closeModal();
    });
  }

  uploadReflect() {
    if (!this.fileName) return;
    const storeId = this.$route.params.store_id;
    const file = this.$refs.diagram_file.files[0];
    postDiagramApi(storeId, file).then(() => {
      // @TODO: API から diagram_id が返却されるようになれば、getDiagramApi の呼び出しは不要
      getDiagramApi(storeId).then(resp => {
        const diagramId = resp.slice(-1)[0].diagram_id;
        postStoresDiagramApi(storeId, diagramId).then(() => {
          this.$router.push({
            path: getRoutePath("SensorDiagramsEditPage", {
              store_id: storeId
            }),
            query: { diagram_id: String(diagramId) }
          });
          this.closeModal();
        });
      });
    });
  }
  selectFile() {
    this.$refs.diagram_file.click();
  }

  handleDrop(event) {
    this.isDrag = false;
    const files = event.target.files || event.dataTransfer.files;
    this.$refs.diagram_file.files = files;
    this.updateFileName(event);
    event.target.value = null;
  }
  handleDrag(isDrag) {
    this.isDrag = isDrag;
  }

  updateFileName(event) {
    const files = event.target.files || event.dataTransfer.files;
    const file = files[0];
    this.fileName = file.name;
  }
}
